module.exports = __webpack_public_path__ + "static/media/Square.80fb6dcd.svg";